import { isUnknownRecord } from "../narrow";
import type { ValidationContext, ValidationError } from "./types";

function formatTruckKey(key: string): string {
  return key
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace(/^./, (character) => character.toUpperCase());
}

export function validateTruckCapacities(
  data: Record<string, unknown>,
  _context: ValidationContext,
): ValidationError[] {
  if (!isUnknownRecord(data.truckCapacities)) {
    return [
      {
        field: "truckCapacities",
        message: "Configure truckload settings",
      },
    ];
  }

  const errors: ValidationError[] = [];
  let hasEnabledTruck = false;

  const capacities = Object.entries(data.truckCapacities).flatMap(
    ([key, value]) =>
      key === "custom" && Array.isArray(value)
        ? value.map((custom) => ["custom", custom])
        : [[key, value]],
  );
  for (const [key, value] of capacities) {
    if (!isUnknownRecord(value) || value.enabled !== true) continue;
    hasEnabledTruck = true;
    if (
      typeof value.units !== "number" ||
      !Number.isSafeInteger(value.units) ||
      value.units <= 0
    ) {
      errors.push({
        field: "truckCapacities",
        message: `${formatTruckKey(typeof key === "string" ? key : "custom")} capacity must be a whole number greater than 0`,
      });
    }
  }

  if (!hasEnabledTruck) {
    errors.push({
      field: "truckCapacities",
      message: "Enable at least one truck type",
    });
  }

  return errors;
}
